'use client'

import { SportsLiveListType } from "@/type/list"
import api from "@/util/api"
import { useContext, useEffect, useRef, useState } from "react"

import tumb_0 from "@/public/image/etc/live_banner.png"
import tumb_1 from "@/public/image/etc/live_baseball.png"
import tumb_2 from "@/public/image/etc/live_baseball2.png"
import tumb_3 from "@/public/image/etc/live_basketball.png"
import defaultThumnail from "@/public/image/etc/liveCommon.png"
import SectionTitle from "@/components/etc/section_title"
import { NavContext } from "@/context/navContext"
import moment from "moment"
import Slider from "@/components/common/swiper2"
import { SwiperSlide } from "swiper/react"
import { useTranslations } from "next-intl"

export default function SportsLiveRanding() {
    const [liveList, setLiveList] = useState<SportsLiveListType[]>([])
    const listRef = useRef<HTMLUListElement>(null)
    const listRef2 = useRef<HTMLDivElement>(null)

    const p = useTranslations("PageTitle")

    function fetchData() {
        const apiUrl = `/api/live/?page=1`
        api(apiUrl)
            .then(res => res.json())
            .then(({ data }) => {
                // const liveFilter = data.live_list.filter((el: SportsLiveListType)=> el.type == 'live')
                // const liveFilter = data.live.filter((el: SportsLiveListType) => el.states == 'ING' && el.video != '').slice(0, 6)
                if(data && Array.isArray(data.live)){
                    const liveFilter = data.live.filter((el: SportsLiveListType) => el.states == 'ING' || el.video != '' || el.states == "PREP").slice(0, 6)
                    setLiveList(liveFilter)
                }
            })
    }

    useEffect(() => {
        fetchData()
    }, [])
    useEffect(() => {
        const len = liveList.length
        listRef.current?.style.setProperty('--wrap-width', `${(len * 158) + ((len - 1) * 11)}px`)
    }, [liveList])

    return (
        <div className="">
            <SectionTitle shortCut={`/livebroadcast/`} type="sports-live" >{p.rich("실시간중계 b:LIVE", { b: (c)=> <b>{c}</b> })}</SectionTitle>

            <div className="SlideList">
                <Slider titleUrl="/livebroadcast/">
                    {
                        !liveList.length
                            ? [...Array(10)].map((_, index) => (
                                <SwiperSlide key={index} style={{ width: "160px" }}>
                                    <SlideItemsPlaceHolder key={index} />
                                </SwiperSlide>
                            ))
                            : liveList.map((li, index) => (
                                <SwiperSlide key={index} style={{ width: "160px" }}>
                                    <SlideItems key={index} li={li} />
                                </SwiperSlide>
                            ))
                    }
                </Slider>
            </div>
        </div>
    )
}


function SlideItems({ li }: { li: SportsLiveListType }) {
    const { movePage } = useContext(NavContext)
    return (
        <div className={'customList'}
            onClick={e => movePage(`/livebroadcast/${li.states == 'ING' ? `?view_code=${li.code}` : ""}`)}>
            <div>
                <div className={`tumbnail type-${li.states}`}>
                    {
                        li.thumbnail
                            ? <img src={li.thumbnail}
                                alt={li.thumbnail}
                                onError={(e) => {
                                    e.currentTarget.onerror = null;
                                    e.currentTarget.src = defaultThumnail.src;

                                }} />
                            : <div className="empty-thumnail">
                                {
                                    li.leagueName == "HD"
                                        ? li.home_name
                                        : li.leagueName
                                }
                            </div>
                    }
                </div>
                <div className="league-name">{li.leagueName}</div>
                {
                    li.leagueName == 'HD'
                        ? <>
                            <div className="match-info">
                                HD LIVE
                            </div>
                        </>
                        : <>
                            <div className="match-info">
                                <div>{li.date.split(' ')[0]}</div>
                                <div>{li.date.split(' ')[1]}</div>
                            </div>
                            <div className="teams">
                                {
                                    li.away_name
                                        ? <>
                                            <div>
                                                <span className="ha home"></span>
                                                <p>{li.home_name}</p>
                                            </div>
                                            <div>
                                                <span className="ha away"></span>
                                                <p>{li.away_name}</p>
                                            </div>
                                        </>
                                        : <p>{li.home_name}</p>
                                }
                            </div>
                        </>
                }
            </div>
        </div>
    )
}

function SlideItemsPlaceHolder() {
    return (
        <div className={'customList empty'}>
            <div>
                <div className={`tumbnail`}>
                    <div className="empty-thumnail"></div>
                </div>
                <div className="league-name">
                    <p className="placeholder-space"></p>
                </div>
                <div className="match-info">
                    <div>
                        <p className="placeholder-space"></p>
                    </div>
                    <div>
                        <p className="placeholder-space"></p>
                    </div>
                </div>
                <div className="teams">
                    <div>
                        <span className="ha home"></span>
                        <p className="placeholder-space"></p>
                    </div>
                    <div>
                        <span className="ha away"></span>
                        <p className="placeholder-space"></p>
                    </div>
                </div>
            </div>
        </div>
    )
}